import { useState, useImperativeHandle, forwardRef } from 'react';

const SearchBar = forwardRef(({ initialValue, onChange, onBlur, placeholder, size = '', disabled = false }, ref) => {
    const SEARCH_UPDATE_INTERVAL_MILISECONDS = 200;

    const [searchValue, setSearchValue] = useState(initialValue || '');
    const [searchBuffer, setSearchBuffer] = useState();

    useImperativeHandle(ref, () => ({
        resetSearch() {
            setSearchValue('');
        }
    }));

    return <input
        type="search"
        rows={1}
        placeholder={placeholder}
        className={`form-control ${size ? 'form-control-' + size : ''}`}
        value={searchValue}
        onChange={(event) => {
            clearTimeout(searchBuffer);
            setSearchValue(event.target.value);
            setSearchBuffer(setTimeout(() => {
                if (onChange) {
                    onChange(event.target.value)
                }
            }, SEARCH_UPDATE_INTERVAL_MILISECONDS));
        }}
        onBlur={(event) => {
            if (onBlur) {
                onBlur(event.target.value)
            }
        }}
        disabled={disabled}
    />
})

export default SearchBar;
